<template>
    <div class="pagination flex gap-x-6 items-center">
        <span class="n-color-text-weaker">{{ trans('clients.showing') }} {{ meta.from }} – {{ meta.to }} {{ trans('clients.of') }} {{ meta.total }}</span>

        <div class="flex gap-x-2 items-center">
            <nord-button
                :disabled="meta.current_page === 1"
                @click="selectPage(meta.current_page - 1)"
            >
                <nord-icon name="arrow-left"></nord-icon>
            </nord-button>

            <nord-button
                :variant="meta.current_page === 1 ? 'primary' : 'plain'"
                @click="selectPage(1)"
            >1</nord-button>

            <span v-if="leftEllipsis">...</span>

            <nord-button
                v-for="page in pages"
                :key="page"
                @click="selectPage(page)"
                :variant="meta.current_page === page ? 'primary' : 'plain'"
            >
                {{ page }}
            </nord-button>

            <span v-if="rightEllipsis">...</span>

            <nord-button
                @click="selectPage(meta.last_page)"
                :variant="meta.current_page === meta.last_page ? 'primary' : 'plain'"
            >
                {{ meta.last_page }}
            </nord-button>

            <nord-button
                :disabled="meta.current_page === meta.last_page"
                @click="selectPage(meta.current_page + 1)"
                :variant="meta.current_page === meta.last_page ? 'primary' : ''"
            >
                <nord-icon name="arrow-right"></nord-icon>
            </nord-button>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ name: 'NordPagination' })

const props = defineProps({
    meta: {
        type: Object,
        required: true, // expects meta from Laravel pagination
    },
})

const emit = defineEmits(['page-changed'])

function selectPage(page) {
    if (page >= 1 && page <= props.meta.last_page) {
        emit('page-changed', page)
    }
}

const pages = computed(() => {
    const current = props.meta.current_page
    const last = props.meta.last_page
    const pages = []

    const start = Math.max(2, current - 1)
    const end = Math.min(last - 1, current + 1)

    for (let i = start; i <= end; i++) {
        pages.push(i)
    }

    return pages
})

const leftEllipsis = computed(() => props.meta.current_page > 3)
const rightEllipsis = computed(() => props.meta.current_page < props.meta.last_page - 2)
</script>
